import { connect } from 'react-redux';

import { actions as coreActions, selectors as coreSelectors } from '$data/core';

import { actions as socketActions } from '$data/socket';

import App from './App';
import { handleLogout } from './App.utils';

const mapStateToProps = (state) => ({
  isLoading: coreSelectors.getIsLoading(state),
  hasError: !!coreSelectors.getError(state),
  activeSpaces: coreSelectors.getActiveSpaces(state),
  currentSpace: coreSelectors.getCurrentSpace(state),
  user: coreSelectors.getUser(state),
  viewAs: coreSelectors.getViewAs(state),
  institution: coreSelectors.getInstitution(state),
});

const mapDispatchToProps = {
  initializeApp: coreActions.initializeApp,
  changeCurrentSpace: coreActions.changeCurrentSpace,
  socketConnect: socketActions.connect,
  socketSubscribe: socketActions.subscribeByAccessToken,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  handleLogout: handleLogout(stateProps),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(App);
